import { Box, Tab, Tabs } from '@mui/material';
import React, { useEffect } from 'react';
import OptimusTabPanel from '../../../common/components/TabUI/TabPanel';
// import OpenPOInput from './OpenPOInput';
// import BacklogInput from './BacklogTable/BacklogInput';
import OpenPOInputTable from './PoTable/OpenPOInputTable';
import { useNavigate } from 'react-router-dom';

const POBackLogTabs = ({ tab, targeted_date_for_completion_of_analysis }) => {
  const [value, setValue] = React.useState(tab ? tab === "po" ? 0 : 1 : 0);
  const navigate = useNavigate();

  const handleChange = (event, newValue) => {
    setValue(newValue);
    navigate(`/input/daily/${newValue === 0 ? "po" : "backlog"}${targeted_date_for_completion_of_analysis ? `?targeted_date_for_completion_of_analysis=${targeted_date_for_completion_of_analysis}` : ``}`);
  };
  useEffect(() => {
    // dispatch(load_po_from_backend(state));
  }, []);

  return (
    <div>
      <Box className="mx-2 rounded-t-md" sx={{ bgcolor: "white" }}>
        <Tabs
          sx={{
            borderBottom: '1px solid #e8e8e8',
            '& .MuiTabs-indicator': {
              backgroundColor: '#084298',
              display: "flex",
              justifyContent: "center"
            },
            '& .MuiTabs-indicatorSpan': {
              maxWidth: 40,
              width: '100%',
              // backgroundColor: '#635ee7',
            },
          }}
          value={value}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons={false}
          aria-label="scrollable prevent tabs example"
        >
          <Tab disableRipple label="Open PO" />
          <Tab disableRipple label="Backlogs" />
        </Tabs>
        <Box>
          {/* {color_by_options?.map((color_by_option_name, idx) =>
            <Button
              disabled={color_by_option_name === color_by}
              variant='outlined'
              key={`${idx}-color_by_option_name-${color_by_option_name}`}
              onClick={() => { update_color_by(color_by_option_name); }}
            >
              {color_by_option_name}
            </Button>)} */}
          {/* <ColorBy selected_color={color_by} color_by_options={color_by_options} update_color_by={update_color_by} /> */}

        </Box>
        {
          <Box>
            <OptimusTabPanel value={value} index={0} >
              <OpenPOInputTable />
            </OptimusTabPanel>
            <OptimusTabPanel value={value} index={1} >
              {/* <BacklogInput targeted_date_for_completion_of_analysis={targeted_date_for_completion_of_analysis} /> */}
            </OptimusTabPanel>
          </Box>

        }
      </Box>
    </div>
  );
};

export default POBackLogTabs;